const encodeObjectForUrl = (data: Record<string, any>): string => {
  return encodeURIComponent(`<<json>>${JSON.stringify(data)}<</json>>`);
};

export default encodeObjectForUrl;
